/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

/* eslint-disable no-console */
/*
Compares the acceptedParams from the config with the provided params. This will not throw an error, but show a warning in the console if a required param is missing.
*/

var validate = function validate(valid, params, name) {
  if (!valid) {
    console.error("The following data hook does not have params: ".concat(name, ", please add them to its documentation."));
    return false;
  }
  if (typeof valid === 'string') {
    return true;
  }
  var validKeys = Object.keys(valid);

  // Check if params and valid exist
  if (typeof params === 'undefined' || !params) {
    // If there is any required valid params then no params were provided
    if (validKeys.some(function (key) {
      return valid[key].required;
    })) {
      return false;
    }
    return true;
  }

  // Get rewuired valid params
  var required = validKeys.filter(function (key) {
    return valid[key].required;
  });
  for (var i = 0; i < required.length; i += 1) {
    if (!params[required[i]]) {
      console.error("Missing required param: ".concat(required[i], ", from data hook: ").concat(name));
      // If a param isn't provided return false
      return false;
    }
  }
  return true;
};
var validateParams = (function (valid, params, name) {
  var isValid = validate(valid, params, name);
  if (!isValid) {
    console.error('The provided params do not match the required parameters');
  }
});

export { validateParams as default };
